"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../../../../../common/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FolderCard = function FolderCard(_ref) {
  var videoFolderId = _ref.videoFolderId,
      videoProjectCount = _ref.videoProjectCount,
      name = _ref.name,
      connectDropTarget = _ref.connectDropTarget,
      gotoFolder = _ref.gotoFolder,
      isOver = _ref.isOver;
  return connectDropTarget( /*#__PURE__*/_react.default.createElement("div", {
    tabIndex: 0,
    role: "button",
    onKeyDown: gotoFolder(videoFolderId),
    className: (0, _classnames.default)('list-projects__card', {
      'list-projects__card--over': isOver
    }),
    onClick: gotoFolder(videoFolderId)
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    name: "folder",
    color: isOver ? 'white' : 'michael'
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h3", {
    className: "list-projects__card__name"
  }, name), /*#__PURE__*/_react.default.createElement("p", null, (0, _utils.projectCountString)(videoProjectCount)))));
};

var _default = FolderCard;
exports.default = _default;